import React, { useState } from 'react';
import { TextField, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

export const ItemsPerPageInput = ({
    value,
    onChange,
    disabled,
}: {
    value: number;
    onChange: (val: number) => void;
    disabled: boolean,
}) => {
    const classes = useStyles();
    const [localVal, setLocalVal] = useState(`${value}`);
    const [localNum, setLocalNum] = useState(value);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (disabled) return;
        const newVal = parseInt(localVal);
        if (!isNaN(newVal)) {
            setLocalNum(newVal);
            setLocalVal(newVal.toString());
            onChange(newVal);
        } else {
            setLocalVal(localNum.toString());
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <TextField
                label="Items per page"
                type="number"
                value={localVal}
                onChange={e => {
                    setLocalVal(e.currentTarget.value);
                }}
                onBlur={e => {
                    const newVal = parseInt(localVal);
                    if (!isNaN(newVal)) {
                        setLocalNum(newVal);
                        setLocalVal(newVal.toString());
                    } else {
                        setLocalVal(localNum.toString());
                    }
                }}
                disabled={disabled}
            />
            <Button
                type="submit"
                className={classes.setButton}
                variant="contained"
                color="primary"
                disabled={disabled}
            >
                Set
            </Button>
        </form>
    );
};

const useStyles = makeStyles({
    setButton: {
        verticalAlign: 'bottom'
    }
});
